import PubSwitcherCard from 'components/PubSwitcherCard/PubSwitcherCard';
import {useGlobalState} from 'hooks/useGlobalState';
import useStopScroll from 'hooks/useStopScroll';
import PubBase from 'typescript/models/PubBase';
import './PubSwitcher.scss';

interface IProps {
  pubs: PubBase[];
  onClose: () => void;
}

export default function PubSwitcher({pubs, onClose}: IProps) {
  const {managedPub} = useGlobalState((state) => state.managedPub);

  const activePub = pubs.find((pub) => String(pub.id) === managedPub!.id);
  const filteredListOfPubs = pubs.filter((pub) => pub.id !== activePub!.id);
  const changedListOfPubs = [activePub!, ...filteredListOfPubs];

  useStopScroll();

  return (
    <div className="pub-switcher" data-testid="pub-switcher">
      <div className="pub-switcher__bg" role="button" onClick={onClose}>
        <div className="pub-switcher__content">
          {changedListOfPubs.map((pub) => (
            <div className="pub-switcher__item" key={pub.id}>
              <PubSwitcherCard pub={pub} active={managedPub!.id === String(pub.id)} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
